<template>
  <div v-if="isVisible" class="custom-alerts vue" @mouseenter="alertHold" @mouseleave="alertResume" :id="alertId"
    :style="{ opacity: isVisible ? '1' : '0' }">
    <div class="custom-alert" :class="colorClass"
      :style="{ transform: isAnimate ? 'translateY(0)' : 'translateY(200%)' }">
      <img class="custom-alert-img" :src="`/img/notifications/${colorClass}.svg`" alt="Notification Icon" />
      <button type="button" class="close" aria-hidden="true" @click="closeAlert"></button>
      <p class="alert-text">{{ text }}</p>
      <div class="close-informer" :style="{ width: progressWidth }"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      isAnimate: false,
      alertId: `alert-${Date.now()}`,
      progressWidth: "0%",
    };
  },
  props: {
    text: { type: String, required: true },
    colorClass: { type: String, default: "alert-success" },
    duration: { type: Number, default: 3000 },
  },
  mounted() {
    this.isVisible = true;
    setTimeout(() => {
      this.isAnimate = true
    }, 50)
    this.startProgress();
    setTimeout(this.closeAlert, this.duration);
  },
  methods: {
    startProgress() {
      setTimeout(() => {
        this.progressWidth = "100%";
      }, 0);

      setTimeout(this.closeAlert, this.duration);
    },
    alertHold() {
      clearTimeout(this.timer);
      this.remainingTime -= Date.now() - this.startTime;
    },
    alertResume() {
      this.startTime = Date.now();
      this.timer = setTimeout(this.closeAlert, this.remainingTime);
    },
    closeAlert() {
      this.isAnimate = false;
      clearTimeout(this.timer)
      setTimeout(() => {
        this.isVisible = false
        this.$el?.remove();
        this.$.appContext.app.unmount();
      }, 400);
    },
  },
};
</script>

<style lang="scss">
.render-alert-wrap{
  z-index: 1000000;
  position: relative;
}
</style>

<style scoped lang="scss">
.close-informer {
  transition: width 3s;
}

.custom-alerts {
  position: fixed;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  width: 680px;
  z-index: 10000;
  transition: 1s ease-in-out;
  .alert,
  .custom-alert {
    border-radius: 16px;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    gap: 15px;
    color: #505050;
    font-family: "Avenir-Next", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    transition: 0.7s ease-in-out;
    box-shadow: 3px 3px 12px 0px #0000000D;
    box-shadow: -2px -2px 8px 0px #0000000D;
    .alert-text{
      min-width: 85%;
    }
    &:before {
      content: unset;
    }
    &.danger {
      background-color: #FEEBEB;
      border: 1px solid #F432321A;
      .custom-alert-img {
        box-shadow: 0 2px 15px 0 #f4323231;
      }
    }
    &.warning {
      background-color: #FFFAE6;
      border: 1px solid #F75A011A;
      .custom-alert-img {
        box-shadow: 0 2px 15px 0 #F0BB0133;
      }
    }
    &.success {
      background-color: #E7F7EE;
      border: 1px solid #00B2411A;
      .custom-alert-img {
        box-shadow: 0 2px 15px 0 #00B24133;
      }
    }
    .custom-alert-img {
      border-radius: 100px;
      width: 32px;
      height: 32px;
    }
    .custom-alert-label {
      color: #505050;
      font-size: 16px;
      line-height: 24px;
      font-family: "Avenir-Next", sans-serif;
      font-weight: 400;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      @media only screen and (max-width: 768px) {
        display: inline-block;
      }
    }
    .undo {
      margin-left: auto;
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      color: #F75A01;
      user-select: none;
      cursor: pointer;
    }
    .close {
      display: inline-block;
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      width: 18.3px;
      height: 18.3px;
      opacity: 0.5;
      z-index: 3;
      margin-top: -1px;
      font-size: 32px;

      &:before,
      &:after {
        content: "";
        background: #C9C9C9;
        display: block;
        position: absolute;
        width: 100%;
        height: 2px;
        left: 50%;
        top: 50%;
        transform-origin: center center;
      }

      &:before {
        transform: translate(-50%, -50%) rotate(45deg);
      }

      &:after {
        transform: translate(-50%, -50%) rotate(-45deg);
      }
    }
  }
  @media only screen and (max-width: 768px) {
    width: calc(100% - 30px);
    left: 15px;
    transform: unset;
  }
}
</style>